import MarketStateCache from '../../../../../../lib/store-util/MarketStateCache';
import { CalculatedSymbolPrices, checkHideExtraPriceInfoInChartHeader } from '../../../../../../lib/util/ChartingHelpers';

import useIsMobile from '../../../../../../shared_components/hooks/useIsMobile';
import { getChangeStyle } from '../../../../getChangeStyle';
import { priceChange } from '../../helpers';
import InfoStatus from '../InfoStatus/InfoStatus';

import styles from './ExtraPriceInfo.module.scss';

const ExtraPriceInfo = (props: CalculatedSymbolPrices): JSX.Element | null => {
  const {
    changeExtraPrice,
    changedPercentExtraPrice,
    extraPriceDirection,
    hasAfterMarketData,
  } = props;
  const { marketState } = MarketStateCache.use();
  const { isMobile, isTablet } = useIsMobile();

  if (checkHideExtraPriceInfoInChartHeader(marketState, hasAfterMarketData)) return null;

  const changeStyle = getChangeStyle(extraPriceDirection);
  const showSeparator = !isMobile && !isTablet;

  return (
    <div className={styles.closeMarketStyle}>
      {showSeparator && <span className={styles.separator}>&bull;</span>}
      <span className={styles.priceText} style={changeStyle}>
        { priceChange(changeExtraPrice, changedPercentExtraPrice) }
      </span>
      <InfoStatus type={'close'} />
    </div>
  );
};

export default ExtraPriceInfo;
